import { FC } from 'react';
import { IonHeader } from '@ionic/react';
import { AllieHeaderProps } from './Header.types';

export const AllieHeader: FC<AllieHeaderProps> = (props) => (<IonHeader {...props} />);
